import React from 'react';
import { Tooltip as MuiTooltip, IconButton } from '@mui/material';

const EntityDialogSectionHeader: React.FC<{
	title: string;
	subtitle: string;
	hideShowSuffix?: string;
	open?: boolean;
	onToggle?: () => void;
	headerEndIcon?: React.ReactNode;
	headerStartIcon?: React.ReactNode;
	expandIcon?: React.ReactNode;
	expandable?: boolean;
}> = ({
	title,
	subtitle,
	hideShowSuffix,
	open,
	onToggle,
	headerEndIcon,
	headerStartIcon,
	expandIcon,
	expandable = true,
}) => {
	if (!expandable) {
		return (
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					width: '100%',
					padding: '20px 0',
					justifyContent: 'space-between',
					paddingRight: 40,
				}}
			>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						marginLeft: !headerStartIcon ? 80 : 0,
					}}
				>
					{!!headerStartIcon ? (
						<div
							style={{
								width: 80,
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							{headerStartIcon}
						</div>
					) : null}

					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							gap: 4,
							alignItems: 'flex-start',
						}}
					>
						<h2
							style={{
								margin: 0,
								fontSize: 16,
								fontWeight: 400,
								color: 'black',
								textAlign: 'left',
							}}
						>
							{title}
						</h2>
						<p
							style={{
								margin: 0,
								fontSize: 10,
								color: 'rgba(0,0,0,0.54)',
								textAlign: 'left',
							}}
						>
							{subtitle}
						</p>
					</div>
				</div>

				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: 12,
					}}
				>
					{headerEndIcon}
				</div>
			</div>
		);
	}

	return (
		<div
			onClick={() => onToggle()}
			style={{
				width: '100%',
				padding: '20px 0',
				cursor: 'pointer',
			}}
		>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					width: '100%',
					justifyContent: 'space-between',
					paddingRight: 40,
				}}
			>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						marginLeft: !headerStartIcon ? 80 : 0,
					}}
				>
					{!!headerStartIcon ? (
						<div
							style={{
								width: 80,
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							{headerStartIcon}
						</div>
					) : null}

					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							gap: 4,
							alignItems: 'flex-start',
						}}
					>
						<h2
							style={{
								margin: 0,
								fontSize: 16,
								fontWeight: 400,
								color: 'black',
								textAlign: 'left',
							}}
						>
							{title}
						</h2>
						<p
							style={{
								margin: 0,
								fontSize: 10,
								color: 'rgba(0,0,0,0.54)',
								textAlign: 'left',
							}}
						>
							{subtitle}
						</p>
					</div>
				</div>

				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: 12,
					}}
				>
					{headerEndIcon}
					<MuiTooltip
						placement='bottom'
						enterDelay={300}
						leaveDelay={200}
						arrow
						title={`${open ? 'Hide' : 'Show'} ${hideShowSuffix || 'section'}`}
					>
						<IconButton
							id='collapse-entity-metadata-section-button'
							aria-label='collapse'
							size='small'
							// color='primary'
							style={{ width: 24, height: 24, fontSize: 16 }}
							onClick={(e) => {
								e.stopPropagation();
								onToggle?.();
							}}
						>
							{/* Add rotation class to chevron if it is open */}
							{expandIcon || (
								<i
									className={`search-statement-dialog__collapse_section-icon fa-regular fa-chevron-down ${
										open ? 'rotate-180' : ''
									}`}
								/>
							)}
						</IconButton>
					</MuiTooltip>
				</div>
			</div>
		</div>
	);
};

export default EntityDialogSectionHeader;
